angular.module('main').directive('snInputText', () => ({
	restrict: 'AE',
	scope: {
		title: '@snTitle',
		model: '=snModel',
		snPlaceholder: '@',
		id: '@snId'
	},
	template(element, attr) {
		let template = '';

		template += '<div class="field-info">';
		template += '<h4>{{title}}</h4>';
		template +=
			'<input id="{{id}}" class="form-control" type="text" placeholder="{{snPlaceholder}}"';
		template += 'ng-model="model" required maxlength="255">';
		template += '</div>';

		return template;
	},
	replace: true,
	link(scope, elem, attr, ctrl) {}
}));



// WEBPACK FOOTER //
// ./web/js/components/Filelds/snFieldInput.js